<template>
  <div>
    <div class="main-wrapper">
      <layout-header @changedLanguage="changedLanguage"></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> {{ $t('processing_activity') }} </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">{{ $t('processing_activity') }}</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-2">

              </div>
              <div class="col-10 text-right">
                <ul class="list-inline-item pl-0">
                  <li class="list-inline-item">
                    <DisplayColumnsComponent :table="table" :columns="columns" v-if="table"></DisplayColumnsComponent>
                  </li>
                  <li class="list-inline-item">
                    <button class="btn font-weight-bold text-white btn-rounded" style="background-color: #5a6268;" @click="openCreateVTsModal">VTs erstellen</button>
                  </li>
                  <li class="list-inline-item">
                    <button class="add btn btn-gradient-primary font-weight-bold text-white todo-list-add-btn btn-rounded" @click="openVTSelectModal">
                      {{ $t('new_entry') }}</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Content Starts -->
          <DataTableDSMS
            ref="dataTableDSMS"
            title="Verarbeitungstätigkeiten"
            fileName="vts"
            modelName="vt"
            deleteURL="todos/v1/delete_vt/"
            :extraActions="extraActions"
            :editorPatchURL="editorPatchURL"
            :columns="columns"
            :objects="vt_list"
            :exportColumns="[0, 1, 7]"
            :extraExportButtons="extraExportButtons"
            :editorCallback="true"
            :editorOnCallback="addNewRiskAnalysis"
            @tableCreated="setTable"
            @editorCreated="setEditor"
            @showObject="showVT"
            @callDrawback="drawCallbackFunctions"
            @editorUpdated="setVT"
            v-if="promiseFinished"
          ></DataTableDSMS>

          <FingerPrintSpinner v-show="!promiseFinished" color="#9b3136" :size="300" :container-padding="100" />
          <!-- /Content End -->

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->
    </diV>

    <!--modal section starts here-->
    <vt :currentVT="current_vt" @vtUpdated="setVT" @completeRiskAnalysis="triggerCompleteRiskAnalysis" @simpleRiskAnalysis="triggerSimpleRiskAnalysis">
      <template v-slot:fileUpload><file-upload :commentObject="current_vt" modelName="vt" @attachmentUpdated="setVT" modelVerboseName="VT"></file-upload></template>
      <template v-slot:comments><comments :commentObject="current_vt" modelName="vt" @commentUpdated="setVT" modelVerboseName="VT"></comments></template>
    </vt>
    <task :currentTodo="currentTodo" origin="currentTodo.model" :editTodoProps="editTodo" @editTodoChanged="changeEditTodo" @todoUpdated="updateTodo">
      <template v-slot:steps>
        <Steps
          :totalSteps="currentTodo.steps"
          :taskID="currentTodo.id"
          :editTodo="editTodo"
          @stepsUpdated="setSteps"
        ></Steps>
      </template>
    </task>
    <div class="modal fade" id="copy-vt" role="dialog" tabindex="-1" aria-modal="true" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <button type="button" class="close md-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title text-center">neue VT Erstellen</h4>
            <button type="button" class="close xs-close" data-dismiss="modal">×</button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <div class="col-md-12 d-flex">
                <button type="button" class="btn btn-outline-info btn-rounded" data-dismiss="modal" @click="chooseVT('new')">leere VT erstellen</button>
              </div>
            </div>
            <div class="van-divider"></div>
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">aus Vorlage kopieren</label>
                <select class="form-control" id="templateVT" v-model="selectedVT" v-select2>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">aus bestehenden kopieren</label>
                <select class="form-control" id="copyVT" v-model="selectedVT" v-select2>
                </select>
              </div>
            </div>
            <div class="col-md-12 text-center mt-2">
              <button type="button" class="border-0 btn btn-primary btn-gradient-primary btn-rounded" @click="chooseVT('copy')">Weiter</button>&nbsp;&nbsp;
              <button type="button" class="btn btn-secondary btn-rounded" data-dismiss="modal">Abbrechen</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-popup" id="current-comments" v-show="showCurrentComments">
      <div class="mt-1"><button type="button" class="close-popup pull-right btn btn-sm btn-light" @click="showCurrentComments = !showCurrentComments"><span>&times;</span></button></div>
      <div class="d-flex mt-3 p-1 border-bottom" v-for="comment in currentComments" :key="'popup-comment-' + comment.id">
        <div class="flex-grow-1">
          <h5 class="mt-0 mb-0 fs-14 text-muted text-left">
            <span class="float-right text-muted fs-12">{{comment.modified}}</span>{{comment.modified_by}}
          </h5>
          <p class="mt-1 mb-0 text-left">
            {{comment.comment}}
          </p>
        </div>
      </div> <!-- end comment -->
    </div>

    <supplier :supplier="current_supplier" @supplierUpdated="setSupplier">
      <template v-slot:fileUpload><file-upload :commentObject="current_supplier" modelName="supplier" @attachmentUpdated="setSupplier" modelVerboseName="Dienstleister"></file-upload></template>
      <template v-slot:comments><comments :commentObject="current_supplier" modelName="supplier" @commentUpdated="setSupplier" modelVerboseName="Dienstleister"></comments></template>
    </supplier><!-- modal -->

    <system :currentSystem="current_system" :departments="departments" @systemUpdated="setSystem">
      <template v-slot:fileUpload><file-upload :commentObject="current_system" modelName="system" @attachmentUpdated="setSystem" modelVerboseName="System"></file-upload></template>
      <template v-slot:comments><comments :commentObject="current_system" modelName="system" @commentUpdated="setSystem" modelVerboseName="System"></comments></template>
    </system>

    <RiskAnalysisComponent :bsi-groups="bsiGroups" :dsgvo-groups="dsgvoGroups" :verbose-names="verboseName" :help-text="helpText" :risk-analysis="currentRiskAnalysis" @riskAnalysisUpdated="setRiskAnalysis">
      <template v-slot:comments><comments :commentObject="currentRiskAnalysis" modelName="riskanalysis" @commentUpdated="setRiskAnalysis" modelVerboseName="RiskAnalysis"></comments></template>
    </RiskAnalysisComponent>


    <SimpleRiskAnalysis survey-title="Einfache Risikobewertung" :survey-json="surveyBody" @simpleRiskAnalysisCompleted="updateSimpleRiskAnalysis" :risk-analysis="currentRiskAnalysis" :survey-result="surveyResult"></SimpleRiskAnalysis>

    <Modal
      title="VTs erstellen"
      v-if="showCreateVTsModal"
      width="60%"
      @close="showCreateVTsModal = false">
      <h4 slot="header">VTs erstellen</h4>
      <div slot="body">
        <div class="form-group row">
          <div class="col-12">
            <label class="font-weight-bold">1. Unternehmen:</label>
          </div>
          <div class="col-md-6 mb-2">
            <label for="company-name" class="col-form-label-sm">Name:</label>
            <input type="text" id="company-name" class="form-control" v-model="createVTsData.companyName" placeholder="Name" />
          </div>
          <div class="col-md-6 mb-2">
            <label for="legal-form" class="col-form-label-sm">Rechtsform:</label>
            <input type="text" id="legal-form" class="form-control" v-model="createVTsData.legalForm" placeholder="Rechtsform" />
          </div>
          <div class="col-md-6 mb-2">
            <label for="company-location" class="col-form-label-sm">Sitz:</label>
            <input type="text" id="company-location" class="form-control" v-model="createVTsData.location" placeholder="Sitz" />
          </div>
          <div class="col-md-6 mb-2">
            <label for="branche" class="col-form-label-sm">Branche:</label>
            <select id="branche" name="branche" class="form-control select" v-model="createVTsData.branche" @change="onBrancheChange">
              <option value="">Bitte auswählen</option>

              <optgroup label="Dienstleistungen">
                <option value="beratung">Beratung und Consulting</option>
                <option value="marketing">Marketing und Werbung</option>
                <option value="recruiting">Personalvermittlung und Recruiting</option>
                <option value="reinigung">Reinigung und Facility Management</option>
                <option value="sicherheit">Sicherheitsdienstleistungen</option>
                <option value="uebersetzung">Übersetzungen und Sprachdienstleistungen</option>
                <option value="sonstige_dienstleistungen">Sonstige Dienstleistungen</option>
              </optgroup>

              <optgroup label="Handel und Verkauf">
                <option value="einzelhandel">Einzelhandel</option>
                <option value="grosshandel">Großhandel</option>
                <option value="e_commerce">E-Commerce und Onlinehandel</option>
                <option value="import_export">Import und Export</option>
                <option value="automobilhandel">Automobilhandel</option>
                <option value="sonstiger_handel">Sonstiger Handel</option>
              </optgroup>

              <optgroup label="Technologie und Medien">
                <option value="softwareentwicklung">Softwareentwicklung</option>
                <option value="it_dienstleistungen">IT-Dienstleistungen</option>
                <option value="saas">SaaS und Cloud-Dienste</option>
                <option value="telekommunikation">Telekommunikation</option>
                <option value="medien">Medien und Verlage</option>
                <option value="film_und_video">Film, Video und Produktion</option>
                <option value="sonstige_technologie">Sonstige Technologiebranche</option>
              </optgroup>

              <optgroup label="Finanzen und Versicherungen">
                <option value="bankwesen">Bankwesen</option>
                <option value="finanzdienstleistungen">Finanzdienstleistungen</option>
                <option value="versicherung">Versicherungen</option>
                <option value="steuerberatung">Steuerberatung</option>
                <option value="wirtschaftspruefung">Wirtschaftsprüfung</option>
                <option value="buchhaltung">Buchhaltung und Rechnungswesen</option>
                <option value="immobilien">Immobilienwirtschaft</option>
              </optgroup>

              <optgroup label="Gesundheit und Soziales">
                <option value="arztpraxis">Arztpraxis und medizinische Versorgung</option>
                <option value="pflege">Pflege und Betreuung</option>
                <option value="therapie">Therapie und Beratung</option>
                <option value="apotheke">Apotheke und Arzneimittel</option>
                <option value="fitness">Fitness und Wellness</option>
                <option value="soziale_einrichtung">Soziale Einrichtung</option>
                <option value="sonstige_gesundheit">Sonstige Gesundheitsbranche</option>
              </optgroup>

              <optgroup label="Industrie und Produktion">
                <option value="maschinenbau">Maschinenbau</option>
                <option value="automobilindustrie">Automobilindustrie</option>
                <option value="elektrotechnik">Elektrotechnik und Elektronik</option>
                <option value="chemie">Chemische Industrie</option>
                <option value="pharma">Pharmaindustrie</option>
                <option value="lebensmittelproduktion">Lebensmittelproduktion</option>
                <option value="textil">Textil- und Bekleidungsindustrie</option>
                <option value="sonstige_produktion">Sonstige Produktion</option>
              </optgroup>

              <optgroup label="Bauwesen und Handwerk">
                <option value="bauunternehmen">Bauunternehmen</option>
                <option value="architektur">Architektur und Planung</option>
                <option value="ingenieurwesen">Ingenieurwesen</option>
                <option value="elektrohandwerk">Elektrohandwerk</option>
                <option value="sanitaer_heizung_klima">Sanitär, Heizung und Klima</option>
                <option value="maler_und_lackierer">Maler- und Lackiererhandwerk</option>
                <option value="schreinerei">Schreinerei und Tischlerei</option>
                <option value="sonstiges_handwerk">Sonstiges Handwerk</option>
              </optgroup>

              <optgroup label="Transport und Logistik">
                <option value="spedition">Spedition</option>
                <option value="logistik">Logistik</option>
                <option value="kurierdienst">Kurier- und Paketdienst</option>
                <option value="personenverkehr">Personenverkehr</option>
                <option value="lagerung">Lagerung und Fulfillment</option>
                <option value="sonstiger_transport">Sonstiger Transport</option>
              </optgroup>

              <optgroup label="Gastronomie, Tourismus und Freizeit">
                <option value="gastronomie">Gastronomie</option>
                <option value="hotel">Hotel und Beherbergung</option>
                <option value="reiseveranstalter">Reiseveranstalter und Reisebüro</option>
                <option value="veranstaltungen">Veranstaltungen und Eventmanagement</option>
                <option value="sport_und_freizeit">Sport und Freizeit</option>
                <option value="kultur">Kultur und Unterhaltung</option>
              </optgroup>

              <optgroup label="Bildung und Forschung">
                <option value="schule">Schule und Bildungseinrichtung</option>
                <option value="weiterbildung">Weiterbildung und Schulung</option>
                <option value="kindergarten">Kindergarten und Kinderbetreuung</option>
                <option value="hochschule">Hochschule und Universität</option>
                <option value="forschung">Forschung und Entwicklung</option>
              </optgroup>

              <optgroup label="Landwirtschaft und Umwelt">
                <option value="landwirtschaft">Landwirtschaft</option>
                <option value="forstwirtschaft">Forstwirtschaft</option>
                <option value="gartenbau">Gartenbau und Landschaftspflege</option>
                <option value="energie">Energieversorgung</option>
                <option value="abfallwirtschaft">Abfallwirtschaft und Recycling</option>
                <option value="umweltdienstleistungen">Umweltdienstleistungen</option>
              </optgroup>

              <optgroup label="Öffentlicher Bereich und Organisationen">
                <option value="oeffentliche_verwaltung">Öffentliche Verwaltung</option>
                <option value="verein">Verein</option>
                <option value="verband">Verband</option>
                <option value="stiftung">Stiftung</option>
                <option value="religionsgemeinschaft">Religionsgemeinschaft</option>
                <option value="nicht_regierungsorganisation">Nichtregierungsorganisation</option>
              </optgroup>

              <option value="sonstige">Sonstige Branche</option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-12">
            <label for="target-audience" class="font-weight-bold">2. Zielgruppen/Kunden:</label>
            <input type="text" id="target-audience" class="form-control" v-model="createVTsData.targetAudience" placeholder="z. B. B2B, Endverbraucher, etc." />
          </div>
        </div>

        <div class="form-group row">
          <div class="col-12">
            <label for="affected-persons" class="font-weight-bold">3. Betroffene Personen:</label>
            <input type="text" id="affected-persons" class="form-control" v-model="createVTsData.affectedPersons" placeholder="z. B. Mitarbeiter, Bewerber, Kunden, Leads, Lieferanten" />
          </div>
        </div>

        <div class="form-group row">
          <div class="col-12">
            <label for="tools-software" class="font-weight-bold">4. Wichtigste Tools & Software:</label>
            <input type="text" id="tools-software" class="form-control" v-model="createVTsData.toolsSoftware" placeholder="z. B. M365, Personio, DATEV, HubSpot, Webserver bei Hetzner" />
          </div>
        </div>

        <div class="form-group row">
          <div class="col-12">
            <label for="special-data" class="font-weight-bold">5. Besondere Daten nach Art. 9 DSGVO:</label>
            <input type="text" id="special-data" class="form-control" v-model="createVTsData.specialData" placeholder="z. B. nur Krankmeldungen im HR-Bereich" />
          </div>
        </div>

        <div class="form-group row">
          <div class="col-12">
            <label for="online-shop" class="font-weight-bold">6. E-Commerce (Online Shop Vorhanden):</label>
            <input type="text" id="online-shop" class="form-control" v-model="createVTsData.onlineShop" placeholder="z. B. Online Shop vorhanden" />
          </div>
        </div>

        <div class="form-group row">
          <div class="col-12">
            <label for="third-country-transfers" class="font-weight-bold">7. Datentransfers in Drittländer:</label>
            <input type="text" id="third-country-transfers" class="form-control" v-model="createVTsData.thirdCountryTransfers" placeholder="z. B. US-Tools mit EU-US DPF / Standardvertragsklauseln" />
          </div>
        </div>

        <div class="form-group row">
          <div class="col-12">
            <label for="others" class="font-weight-bold">8. Zusätzliche Beschreibungen:</label>
            <textarea id="others" rows="3" class="form-control" v-model="createVTsData.others" placeholder="z. B. Klinik hat noch eine Schule für die jungen Patienten." />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary btn-sm mr-2" :disabled="isGeneratingVTs" @click="generateVTs">
          <i class="fa fa-spinner fa-spin mr-1" v-if="isGeneratingVTs"></i>erstellen
        </button>
        <button class="btn btn-secondary btn-sm" :disabled="isGeneratingVTs" @click="showCreateVTsModal = false">schliessen</button>
      </span>
    </Modal>

  </div>
</template>
<script>
  import {service, baseURL} from '@/utils/request.js';
  import {
    CLOSED_STATUS,
    deepCopy,
    boolDisplay,
    initSelect2,
    updateSystems,
    updateDepartments,
    updatePersonGroups,
    updateDataTypes,
    updateSuppliers,
    ajaxErrorMessage
  } from '@/utils/index.js';
  import {
    newSystem,
    newTodo,
    newSupplier,
    newVT,
    newRiskAnalysis,
    objectModalName,
    RISKLEVEL,
    dataTypeCategory,
    numberOfPerson,
    categoryChoices,
    personNumberChoices,
    brancheDefaults
  } from '@/utils/enums.js';
  import {mapGetters, mapMutations, mapState} from 'vuex';
  import datePicker from 'vue-bootstrap-datetimepicker';
  import { Uploader, Button } from 'vant';
  import { useVuelidate } from '@vuelidate/core';
  import { required } from '@vuelidate/validators';
  import DataTableDSMS from "@/components/component/DataTableDSMS";
  import Steps from "@/components/component/Steps";
  import SystemComponent from "@/components/component/SystemComponent";
  import VendorComponent from "@/components/component/VendorComponent";
  import CommentComponent from "@/components/component/CommentComponent";
  import FileUploadComponent from "@/components/component/FileUploadComponent";
  import TodoComponent from "@/components/component/TodoComponent.vue";
  import VTComponent from "@/components/component/VTComponent.vue";
  import DisplayColumnsComponent from "@/components/component/DisplayColumnsComponent.vue";
  import DKLVendor from "@/components/component/VendorComponent.vue";
  import FingerPrintSpinner from "@/components/component/FingerPrintSpinner.vue";
  import RiskAnalysisComponent from "@/components/component/RiskAnalysisComponent.vue";
  import SimpleRiskAnalysis from "@/components/component/SimpleRiskAnalysisComponent.vue";
  import Modal from "@/components/component/Modal.vue";

  export default {
    components: {
      Modal,
      SimpleRiskAnalysis,
      RiskAnalysisComponent,
      FingerPrintSpinner,
      DKLVendor,
      DisplayColumnsComponent,
      'van-uploader': Uploader,
      'van-button': Button,
      datePicker,
      DataTableDSMS,
      Steps,
      'system': SystemComponent,
      'supplier': VendorComponent,
      'comments': CommentComponent,
      'file-upload': FileUploadComponent,
      'task': TodoComponent,
      'vt': VTComponent
    },
    data() {
      return {
        showCreateVTsModal: false,
        isGeneratingVTs: false,
        createVTsData: {
          companyName: '',
          legalForm: '',
          location: '',
          branche: '',
          dsb: 'Ja/Nein, ggf. Kontaktdaten',
          targetAudience: 'z. B. B2B, Endverbraucher, etc.',
          affectedPersons: 'z. B. Mitarbeiter, Bewerber, Kunden, Leads, Lieferanten',
          toolsSoftware: 'z. B. M365, Personio, DATEV, HubSpot, Webserver bei Hetzner',
          specialData: 'z. B. nur Krankmeldungen im HR-Bereich',
          onlineShop: 'z. B. Online Shop vorhanden',
          thirdCountryTransfers: 'z. B. US-Tools mit EU-US DPF / Standardvertragsklauseln',
          others: '',
        },
        skipBrancheWatcher: false,
        datetimeOptions: {
          format: 'YYYY-MM-DD',
          useCurrent: false,
        },
        promiseFinished: false,
        surveyBody: {},
        surveyResult: {},
        editorPatchURL: '/todos/v1/patch_vt/',
        extraExportButtons: [
          {text: 'Word', action: (e, dt, node, config) => {
              let selectedRows = dt.rows({selected: true});
              if (selectedRows.count() === 0) selectedRows = dt.rows()
              service.request({
                url: 'todos/v1/get_vt_word/',
                method: 'POST',
                data: JSON.stringify({
                  data: selectedRows.data().toArray(),
                  mandant: this.account.name,
                  address: this.account.address,
                  dsb: this.account.dsb,
                  phone: this.account.phone,
                  website: this.account.website,
                  email: this.account.email,
                  mandant_id: this.accountid
                }),
                contentType: 'application/json; charset=utf-8',
                responseType: 'blob'
              }).then(function(response) {
                // more general way
                // let filename = "";
                // const disposition = xhr.getResponseHeader('Content-Disposition');
                // if (disposition && disposition.indexOf('attachment') !== -1) {
                //   const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                //   const matches = filenameRegex.exec(disposition);
                //   if (matches !== null && matches[1]) {
                //     filename = matches[1].replace(/['"]/g, '');
                //   }
                // }
                const fileName = response.headers['content-disposition'].split('filename=')[1].split(';')[0];
                let blob = new Blob([response.data], { type: response.headers['content-type'] });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download =fileName;
                link.click()
              }).catch(function(err) {
                console.log(err)
              })
            }}
        ],
        showCurrentComments: false,
        editSystem: false,
        editTodo: false,
        vt_list: [],
        current_question: {},
        current_system: newSystem,
        current_supplier: newSupplier,
        current_vt: {},
        currentTodo: {},
        currentComments: [],
        newComment: '',
        table: null,
        editor: null,
        selectedVT: null,
        bsiGroups: [],
        dsgvoGroups: [],
        verboseName: {},
        helpText: {},
        currentRiskAnalysis: newRiskAnalysis
      }
    },
    validations() {
      return {
        currentTodo: {
          due_date: {required, $lazy: true},
          description: {required, $lazy: true}
        },
        newStep: {
          name: {required, $lazy: true}
        },
        currentStep: {
          name: {required, $lazy: true}
        },
        current_system: {
          name: {required, $lazy: true},
          purpose: {required, $lazy: true},
          storage_place: {required, $lazy: true},
        },
        current_vt: {
          name: {required, $lazy: true},
          purpose: {required, $lazy: true}
        },
        $validationGroups: {
          updateGapGroup: ['current_question', 'new_answer.comments'],
          newGapGroup: ['current_question', 'newQuestionID'],
        }
      }
    },
    setup() {
      return {
        v$: useVuelidate()
      }
    },
    created() {
      this.current_vt = deepCopy(newVT)
      this.getQuestions()
      this.getTemplateVTHeaders()
      this.getRiskMeta()
    },
    mounted() {
      initSelect2()
    },
    beforeDestroy() {
    },
    watch: {
      selectVorlageOptions(newValue, oldValue) {
        if (newValue.length > 0) {
          $('#copyVT').select2({
            width: '100%',
            dropdownParent: $('#copy-vt'),
            allowClear: true,
            placeholder: "--------",
            data: newValue
          })
        }
      },
      selectedVT(newValue, oldValue) {
        if (newValue === undefined) this.selectedVT = oldValue
        if (oldValue && newValue) {
          if (newValue.startsWith('vorlage')) $('#copyVT').val(newValue).trigger('change')
          else $('#templateVT').val(newValue).trigger('change')
        }
      },
      'createVTsData.branche'(newValue) {
        if (this.skipBrancheWatcher) {
          return;
        }
        this.applyBrancheDefaults(newValue);
      }
    },
    computed: {
      ...mapState({
        accountid: state => state.account.accountid,
        userName: state => state.user.username,
        account: state => state.account,
        userID: state => state.user.id,
        departments: state => state.account.departments,
        systems: state => state.account.systems,
        suppliers: state => state.account.suppliers,
        personGroups: state => state.account.personGroups,
        dataTypes: state => state.account.dataTypes,
      }),
      ...mapGetters(['selectDepartmentOptions', 'selectSystemOptions', 'selectSupplierOptions', 'selectPersonGroupsOptions', 'selectDataTypeOptions']),
      dataReady() {
        // return this.departments.length > 0 && this.vt_list.length > 0 && this.dataTypes.length > 0 && this.systems.length > 0
        return this.vt_list.length > 0
      },
      modelObjects() {
        return {
          system: this.current_system,
          task: this.currentTodo,
          vt: this.current_vt
        }
      },
      createAPI() {
        return {
          vt: `todos/v1/vt/${this.accountid}/`,
          system: `todos/v1/system/${this.accountid}/`,
          task: `todos/v1/task/${this.accountid}/`,
        }
      },
      selectVorlageOptions() {
        const vorlageData = []
        this.vt_list.forEach(vt => vorlageData.push({
          id: vt.id,
          text: vt.name
        }))
        return vorlageData
      },
      currentDateString() {
        return new Date().toLocaleDateString()
      },
      reversedDataTypeCategory() {
        let options = {}
        Object.keys(categoryChoices).forEach(key => {
          options[categoryChoices[key]] = key
        })
        return options
      },
      reversedPersonNumber() {
        let options = {}
        Object.keys(personNumberChoices).forEach(key => {
          options[personNumberChoices[key]] = key
        })
        return options
      },

      columns() {
        return [
          {
            label: 'Nr.#',
            name: 'sequence',
            enableEditor: false,
            definition: {data: "sequence", width: '100px', className: 'dkl-vt-sequence reorder'},
          },
          {
            label: this.$t('name'),
            name: 'name',
            enableEditor: false,
            definition: { data: null, render: (data) => {
                if (data.comments.length > 0) {
                  return `<div><span>${data.name}</span><br/><a href="#"><span class="text-primary show-comments" data-vt-id="${data.id}"><i class="fa fa-commenting-o" aria-hidden="true"></i> ${data.comments.length}</span></a></div>`
                }
                return `<div><span>${data.name}</span></div>`
              }, width: '200px'},
          },
          {
            label: 'Status',
            name: 'released',
            type: 'radio',
            options: [
              { label: "Angenommen", value: true },
              { label: "Vorgeschlagen",  value: false }
            ],
            enableEditor: true,
            definition: {data: "released", render: (data) => data ? 'Angenommen' : 'Vorgeschlagen'},
          },
          {
            label: this.$t('purpose_data_processing'),
            name: 'purpose',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: {data: "purpose"},
          },
          {
            label: this.$t('description'),
            name: 'description',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: {data: "description", className: 'min-width-350'},
          },
          {
            label: this.$t('departments'),
            name: 'departments',
            type: 'select2',
            opts: {
              multiple: true,
              closeOnSelect: false,
            },
            options: this.selectDepartmentOptions,
            enableEditor: true,
            definition: {data: "departments"},
          },
          {
            label: this.$t('task'),
            name: 'task',
            enableEditor: false,
            definition: { data: "tasks", render: function(data, type, row) {
                let html = '<div class="pipeline-small flat dkl-task">';
                let item_class = 'noselect tipped-top planing';
                for (let i = 0; i < data.length; i++) {
                  item_class = data[i].status === 'Abgeschlossen' ? 'closed noselect tipped-top' : data[i].status.includes('Offen') ? 'open noselect tipped-top planing' : 'noselect tipped-top planing'
                  html += `<a class="${item_class} single-task z-index-0 mr-1" data-task-id="${data[i].id}" href="#" data-vt-id="${row.id}" data-toggle="tooltip" data-placement="top" title="${data[i].description}" data-original-title="${data[i].description}">&nbsp;
                        <span class="stretched-link"  data-task-id="${data[i].id}" data-vt-id="${row.id}"></span>
                      </a>`
                }
                html += '</div>';
                return html
              }},
          },
          {
            label: this.$t('process_type'),
            name: 'process_type',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: {data: "process_type"},
          },
          {
            label: this.$t('supplier'),
            name: 'suppliers',
            type: 'select2',
            opts: {
              multiple: true,
              closeOnSelect: false,
            },
            options: this.selectSupplierOptions,
            enableEditor: true,
            definition: { data: "suppliers", render: (data, type, row) => {
                if (data) {
                  const suppliers = row.supplier_ids || [];
                  let return_html = suppliers.map(item => `<a href="#" class="related-supplier mr-3" data-supplier-id="${item.id}" data-vt-id="${row.id}">${item.text}</a>`).join('');
                  return_html += `<a href="#" class="edit-table-field"><i class="fa fa-pencil"></i></a>`;
                  return return_html;
                } else return `<a href="#" class="add-supplier mr-3" data-vt-id="${row.id}"><i class="fa fa-plus" data-vt-id="${row.id}"></i></a>`;
              }},
          },
          {
            label: this.$t('system'),
            name: 'systems',
            type: 'select2',
            opts: {
              multiple: true,
              closeOnSelect: false,
            },
            options: this.selectSystemOptions,
            enableEditor: true,
            definition: { data: "systems", render: (data, type, row) => {
                if (data == null) return `<a href="#" class="add-system mr-3" data-system-id="${row.system_id}" data-vt-id="${row.id}"><i class="fa fa-plus" data-vt-id="${row.id}"></i></a><a href="#" class="edit-table-field"><i class="fa fa-pencil"></i></a>`;
                else {
                  const systems = row.system_ids || [];
                  let return_html = systems.map(item => `<a href="#" class="related-system mr-3" data-system-id="${item.id}" data-vt-id="${row.id}">${item.text}</a>`).join('');
                  return_html += `<a href="#" class="edit-table-field"><i class="fa fa-pencil"></i></a>`;
                  return return_html;
                }
              }},
          },
          {
            label: this.$t('affected_person'),
            name: 'affected_person',
            type: 'select2',
            opts: {
              multiple: true,
              closeOnSelect: false,
              tags: true,
            },
            options: this.selectPersonGroupsOptions,
            enableEditor: true,
            definition: { data: "affected_person", render: (data) => data.join(',') },
          },
          {
            label: this.$t('data_type'),
            name: 'data_type',
            type: 'select2',
            opts: {
              multiple: true,
              closeOnSelect: false,
              tags: true,
            },
            options: this.selectDataTypeOptions,
            enableEditor: true,
            definition: { data: "data_type", render: (data) => data.join(',') },
          },
          {
            label: this.$t('data_origin'),
            name: 'data_origin',
            type: 'text',
            enableEditor: true,
            definition: {data: "data_origin"},
          },
          {
            label: this.$t('person_informed'),
            name: 'person_informed',
            type: 'radio',
            options: [
              { label: "informiert", value: true },
              { label: "nicht informiert",  value: false }
            ],
            enableEditor: true,
            definition: { data: "person_informed", render: (data, type, row) => `${data == null ? '' : boolDisplay[data]}${row.person_informed_remarks == null ? '' : ' | ' + row.person_informed_remarks}`, editField: ['person_informed', 'person_informed_remarks'] },
          },
          {
            label: this.$t('data_type_category'),
            name: 'data_type_category',
            type: 'radio',
            options: dataTypeCategory,
            enableEditor: true,
            definition: { data: "data_type_category", render: (data) => {
                if (!data) return '-'
                const option = dataTypeCategory.find(item => item.value === data)
                return option.label
              }}
          },
          {
            label: this.$t('number_of_persons'),
            name: 'number_of_persons',
            type: 'radio',
            options: numberOfPerson,
            enableEditor: true,
            definition: { data: "number_of_persons", render: (data) => {
                if (!data) return '-'
                const option = numberOfPerson.find(item => item.value === data)
                return option.label
              }}
          },
          {
            label: this.$t('risk_level'),
            name: 'risk_level',
            type: 'radio',
            options: [
              { label: "Normal", value: 'normal' },
              { label: "Hoch",  value: 'high' },
              { label: "Sehr Hoch",  value: 'very high' },
            ],
            enableEditor: true,
            definition: { data: "risk_level", render: (data, type, row) => row.risk_analysis ? `<a data-vt-id="${row.id}" class="related-risk" href="#">${RISKLEVEL[data]}<span  class="dkl-green ml-1"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span></a>` : RISKLEVEL[data], editField: ['risk_level', 'risk_remarks'] },
          },
          {
            label: this.$t('legal_base.name'),
            name: 'legal_base',
            type: 'select2',
            options: [
              {label: 'Erfüllung einer rechtlichen Verpflichtung (Art. 6 Abs. 1 lit. c DSGVO)', value: 'Erfüllung einer rechtlichen Verpflichtung (Art. 6 Abs. 1 lit. c DSGVO)'},
              {label: 'Vertrag oder Vertragsanbahnung (Art. 6 Abs. 1 lit. b DSGVO)', value: 'Vertrag oder Vertragsanbahnung (Art. 6 Abs. 1 lit. b DSGVO)'},
              {label: 'Wahrung berechtigter Interessen des Verantwortlichen oder eines Dritten (Art. 6 Abs. 1 lit. f)', value: 'Wahrung berechtigter Interessen des Verantwortlichen oder eines Dritten (Art. 6 Abs. 1 lit. f)'},
              {label: 'Einwilligung (Art. 6 Abs. 1 lit. a, Art. 7)', value: 'Einwilligung (Art. 6 Abs. 1 lit. a, Art. 7)'},
              {label: 'Betriebs- oder Einzelvereinbarung', value: 'Betriebs- oder Einzelvereinbarung'},
              {label: 'Schutz lebenswichtiger Interessen des Betroffenen', value: 'Schutz lebenswichtiger Interessen des Betroffenen'},
              {label: 'Wahrung öffentlicher Interessen oder Ausübung öffentlicher Gewalt', value: 'Wahrung öffentlicher Interessen oder Ausübung öffentlicher Gewalt'},
              {label: 'Einwilligung eines Kindes (Art. 6 Abs. 1 lit. a, Art. 8)', value: 'Einwilligung eines Kindes (Art. 6 Abs. 1 lit. a, Art. 8)'},
              {label: 'Sonstiges', value: 'Sonstiges'},
            ],
            enableEditor: true,
            definition: { data: "legal_base", render: (data, type, row) => `${data == null ? '' : data}${row.legal_base_remarks == null ? '' : ' | ' + row.legal_base_remarks}`, editField: ['legal_base', 'legal_base_remarks'] },
          },
          {
            label: this.$t('process_place'),
            name: 'process_place',
            type: 'text',
            enableEditor: true,
            definition: {data: "process_place"},
          },
          {
            label: this.$t('access_rights'),
            name: 'access_rights',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: {data: "access_rights"},
          },
          {
            label: this.$t('storage_duration'),
            name: 'storage_duration',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: {data: "storage_duration"},
          },
          {
            label: this.$t('intern_receipt'),
            name: 'intern_receipt',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: {data: "intern_receipt"},
          },
          {
            label: this.$t('extern_receipt'),
            name: 'extern_receipt',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: {data: "extern_receipt"},
          },

          {
            label: this.$t('data_transfer'),
            name: 'data_transfer',
            type: 'radio',
            options: [
              { label: "findet statt", value: true },
              { label: "findet nicht statt",  value: false }
            ],
            enableEditor: true,
            definition: { data: "data_transfer", render: (data, type, row) => `${data == null ? '' : boolDisplay[data]}${row.data_transfer_remarks == null ? '' : ' | ' + row.data_transfer_remarks}`, editField: ['data_transfer', 'data_transfer_remarks'] },
          },
          {
            label: this.$t('profiling'),
            name: 'profiling',
            type: 'radio',
            options: [
              { label: "findet statt", value: true },
              { label: "findet nicht statt",  value: false }
            ],
            enableEditor: true,
            definition: { data: "profiling", render: (data, type, row) => `${data == null ? '' : boolDisplay[data]}${row.profiling_remarks == null ? '' : ' | ' + row.profiling_remarks}`, editField: ['profiling', 'profiling_remarks'] },
          },
          {
            label: this.$t('evaluation'),
            name: 'evaluation',
            type: 'radio',
            options: [
              { label: "findet statt", value: true },
              { label: "findet nicht statt",  value: false }
            ],
            enableEditor: true,
            definition: { data: "evaluation", render: (data, type, row) => `${data == null ? '' : boolDisplay[data]}${row.evaluation_remarks == null ? '' : ' | ' + row.evaluation_remarks}`, editField: ['evaluation', 'evaluation_remarks'] },
          },
          {
            label: this.$t('document'),
            name: 'document',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: {data: "document"},
          },
          {
            label: this.$t('storage_place'),
            name: 'storage_place',
            type: 'text',
            enableEditor: true,
            definition: {data: "storage_place"},
          },
          {
            label: this.$t('modified'),
            name: 'modified',
            type: 'text',
            enableEditor: false,
            definition: {data: "modified", render: (data) => typeof data === 'string' ? data.substring(0, 10) : ''},
          },
          {
            label: this.$t('risk_remarks'),
            name: 'risk_remarks',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 3
            },
            enableEditor: true,
            definition: false,
          },
          {
            label: this.$t('person_informed_remarks'),
            name: 'person_informed_remarks',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 3
            },
            enableEditor: true,
            definition: false,
          },
          {
            label: this.$t('legal_base_remarks'),
            name: 'legal_base_remarks',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 3
            },
            enableEditor: true,
            definition: false,
          },
          {
            label: this.$t('data_transfer_remarks'),
            name: 'data_transfer_remarks',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 3
            },
            enableEditor: true,
            definition: false,
          },
          {
            label: this.$t('profiling_remarks'),
            name: 'profiling_remarks',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 3
            },
            enableEditor: true,
            definition: false,
          },
          {
            label: this.$t('evaluation_remarks'),
            name: 'evaluation_remarks',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 3
            },
            enableEditor: true,
            definition: false,
          },
          {
            label: this.$t('data_protection'),
            name: 'data_protection',
            className: 'dkl-font-13',
            enableEditor: false,
            definition: {data: "data_protection"},
          },
          {
            label: this.$t('responsible_person'),
            name: 'responsible_person',
            className: 'dkl-font-13',
            enableEditor: false,
            definition: {data: "responsible_person"},
          },
          {
            label: this.$t('storage_should'),
            name: 'storage_should',
            className: 'dkl-font-13',
            enableEditor: false,
            definition: {data: "storage_should"},
          },
          {
            label: this.$t('data_protection'),
            name: 'data_protection',
            className: 'dkl-font-13',
            enableEditor: false,
            definition: {data: "data_protection"},
          },
          {
            label: this.$t('reason_extended_storage'),
            name: 'reason_extended_storage',
            className: 'dkl-font-13',
            enableEditor: false,
            definition: {data: "reason_extended_storage"},
          },
          {
            label: this.$t('delete_method'),
            name: 'delete_method',
            className: 'dkl-font-13',
            enableEditor: false,
            definition: {data: "delete_method"},
          },
          {
            label: this.$t('delete_department'),
            name: 'delete_department',
            className: 'dkl-font-13',
            enableEditor: false,
            definition: {data: "delete_department"},
          },
          {
            label: this.$t('delete_process'),
            name: 'delete_process',
            className: 'dkl-font-13',
            enableEditor: false,
            definition: {data: "delete_process"},
          },
          {
            label: this.$t('storage_legal_base'),
            name: 'storage_legal_base',
            className: 'dkl-font-13',
            enableEditor: false,
            definition: {data: "storage_legal_base"},
          },
          {
            label: this.$t('legitimate_interest'),
            name: 'legitimate_interest',
            className: 'dkl-font-13',
            enableEditor: false,
            definition: {data: "legitimate_interest"},
          },
          {
            label: this.$t('affected_interests'),
            name: 'affected_interests',
            className: 'dkl-font-13',
            enableEditor: false,
            definition: {data: "affected_interests"},
          },
          {
            label: this.$t('interest_balance'),
            name: 'interest_balance',
            className: 'dkl-font-13',
            enableEditor: false,
            definition: {data: "interest_balance"},
          },
          {
            label: this.$t('dsfa'),
            name: 'dsfa',
            className: 'dkl-font-13',
            enableEditor: false,
            definition: {data: "dsfa"},
          },
        ];
      },
    },
    updated ()
    {

    },
    methods: {
      ...mapMutations({setDepartments: 'SET_DEPARTMENTS', setSystems: 'SET_SYSTEMS'}),
      async openCreateVTsModal() {
        const customerId = this.accountid || (this.account && this.account.accountid);
        const startNewForm = () => {
          const initialBranche = this.account && this.account.branche ? this.account.branche : '';
          this.createVTsData = {
            companyName: this.account && this.account.name ? this.account.name : '',
            legalForm: '',
            location: this.account && this.account.address ? this.account.address : '',
            branche: initialBranche,
            dsb: this.account && this.account.dsb ? this.account.dsb : 'Ja/Nein, ggf. Kontaktdaten',
            targetAudience: 'z. B. B2B, Endverbraucher, etc.',
            affectedPersons: 'z. B. Mitarbeiter, Bewerber, Kunden, Leads, Lieferanten',
            toolsSoftware: 'z. B. M365, Personio, DATEV, HubSpot, Webserver bei Hetzner',
            specialData: 'z. B. nur Krankmeldungen im HR-Bereich',
            onlineShop: 'z. B. Online Shop vorhanden',
            thirdCountryTransfers: 'z. B. US-Tools mit EU-US DPF / Standardvertragsklauseln',
            others: '',
          };
          if (initialBranche) {
            this.applyBrancheDefaults(initialBranche);
          }
          this.showCreateVTsModal = true;
        };

        if (!customerId) {
          startNewForm();
          return;
        }

        try {
          const response = await service.request({
            url: `/todos/v1/company_profile/${customerId}/`,
            method: 'GET',
            responseType: 'json'
          });
          const profile = response && response.data ? response.data : {};
          const hasProfile = profile && typeof profile === 'object' && Object.keys(profile).length > 0 &&
            Object.values(profile).some(v => v !== null && v !== undefined && String(v).trim() !== '');

          if (hasProfile) {
            this.skipBrancheWatcher = true;
            this.createVTsData = {
              ...profile,
              companyName: profile.company_name !== undefined && profile.company_name !== null ? profile.company_name : (profile.companyName || (this.account && this.account.name ? this.account.name : '')),
              legalForm: profile.legal_form !== undefined && profile.legal_form !== null ? profile.legal_form : (profile.legalForm || ''),
              location: profile.location !== undefined && profile.location !== null ? profile.location : (this.account && this.account.address ? this.account.address : ''),
              branche: profile.branche !== undefined && profile.branche !== null ? profile.branche : '',
              dsb: profile.dsb || (this.account && this.account.dsb ? this.account.dsb : 'Ja/Nein, ggf. Kontaktdaten'),
              targetAudience: profile.target_audience !== undefined && profile.target_audience !== null ? profile.target_audience : (profile.targetAudience || ''),
              affectedPersons: profile.affected_persons !== undefined && profile.affected_persons !== null ? profile.affected_persons : (profile.affectedPersons || ''),
              toolsSoftware: profile.tools_software !== undefined && profile.tools_software !== null ? profile.tools_software : (profile.toolsSoftware || ''),
              specialData: profile.special_data !== undefined && profile.special_data !== null ? profile.special_data : (profile.specialData || ''),
              onlineShop: profile.online_shop !== undefined && profile.online_shop !== null ? profile.online_shop : (profile.onlineShop || ''),
              thirdCountryTransfers: (profile.third_country_transfer !== undefined && profile.third_country_transfer !== null)
                ? profile.third_country_transfer
                : ((profile.third_country_transfers !== undefined && profile.third_country_transfers !== null) ? profile.third_country_transfers : (profile.thirdCountryTransfers || '')),
              others: profile.others !== undefined && profile.others !== null ? profile.others : '',
              company_name: profile.company_name !== undefined && profile.company_name !== null ? profile.company_name : (profile.companyName || (this.account && this.account.name ? this.account.name : '')),
              legal_form: profile.legal_form !== undefined && profile.legal_form !== null ? profile.legal_form : (profile.legalForm || ''),
              target_audience: profile.target_audience !== undefined && profile.target_audience !== null ? profile.target_audience : (profile.targetAudience || ''),
              affected_persons: profile.affected_persons !== undefined && profile.affected_persons !== null ? profile.affected_persons : (profile.affectedPersons || ''),
              tools_software: profile.tools_software !== undefined && profile.tools_software !== null ? profile.tools_software : (profile.toolsSoftware || ''),
              special_data: profile.special_data !== undefined && profile.special_data !== null ? profile.special_data : (profile.specialData || ''),
              online_shop: profile.online_shop !== undefined && profile.online_shop !== null ? profile.online_shop : (profile.onlineShop || ''),
              third_country_transfer: (profile.third_country_transfer !== undefined && profile.third_country_transfer !== null)
                ? profile.third_country_transfer
                : ((profile.third_country_transfers !== undefined && profile.third_country_transfers !== null) ? profile.third_country_transfers : (profile.thirdCountryTransfers || '')),
              third_country_transfers: (profile.third_country_transfers !== undefined && profile.third_country_transfers !== null)
                ? profile.third_country_transfers
                : ((profile.third_country_transfer !== undefined && profile.third_country_transfer !== null) ? profile.third_country_transfer : (profile.thirdCountryTransfers || '')),
            };
            await this.$nextTick();
            if (profile.target_audience !== undefined && profile.target_audience !== null) {
              this.createVTsData.targetAudience = profile.target_audience;
            }
            if (profile.affected_persons !== undefined && profile.affected_persons !== null) {
              this.createVTsData.affectedPersons = profile.affected_persons;
            }
            if (profile.tools_software !== undefined && profile.tools_software !== null) {
              this.createVTsData.toolsSoftware = profile.tools_software;
            }
            if (profile.special_data !== undefined && profile.special_data !== null) {
              this.createVTsData.specialData = profile.special_data;
            }
            this.skipBrancheWatcher = false;
            this.showCreateVTsModal = true;
          } else {
            startNewForm();
          }
        } catch (error) {
          console.error('Fehler beim Laden des Unternehmensprofils:', error);
          startNewForm();
        }
      },
      onBrancheChange(event) {
        const selectedValue = event && event.target ? event.target.value : this.createVTsData.branche;
        this.applyBrancheDefaults(selectedValue);
      },
      applyBrancheDefaults(brancheKey) {
        if (!brancheKey || !brancheDefaults[brancheKey]) {
          return;
        }
        const defaults = brancheDefaults[brancheKey];
        if (defaults.targetAudience) {
          this.createVTsData.targetAudience = defaults.targetAudience;
        }
        if (defaults.affectedPersons) {
          this.createVTsData.affectedPersons = defaults.affectedPersons;
        }
        if (defaults.specialData) {
          this.createVTsData.specialData = defaults.specialData;
        }
        if (defaults.toolsSoftware) {
          this.createVTsData.toolsSoftware = defaults.toolsSoftware;
        }
      },
      generateVTs() {
        const customerId = this.accountid || (this.account && this.account.accountid);
        if (!customerId) {
          this.$vToastify.error('Kunden-ID nicht gefunden.');
          return;
        }
        this.isGeneratingVTs = true;
        const payload = {
          ...this.createVTsData,
          company_name: this.createVTsData.companyName,
          legal_form: this.createVTsData.legalForm,
          target_audience: this.createVTsData.targetAudience,
          affected_persons: this.createVTsData.affectedPersons,
          tools_software: this.createVTsData.toolsSoftware,
          special_data: this.createVTsData.specialData,
          online_shop: this.createVTsData.onlineShop,
          third_country_transfers: this.createVTsData.thirdCountryTransfers,
        };
        service.request({
          url: `/todos/v1/generate_vts/${customerId}/`,
          method: 'POST',
          data: payload,
          timeout: 180000,
        }).then((response) => {
          this.$vToastify.success(response.data.message);
          this.showCreateVTsModal = false;
        }).catch((err) => {
          const errMsg = err && err.response && err.response.data && (err.response.data.detail || err.response.data.message || err.response.data.error)
            ? (err.response.data.detail || err.response.data.message || err.response.data.error)
            : String(err);
          this.$vToastify.error(errMsg);
        }).finally(() => {
          this.isGeneratingVTs = false;
        });
      },
      async changedLanguage() {
        this.$nextTick(async () => {
          if (this.table) this.table.destroy();
          await this.$refs.dataTableDSMS.initTable();
        });
      },
      openSimpleRiskSurvey() {
        service.get(`survey/v1/survey_by_name/?name=${encodeURIComponent("einfache Risikobewertung")}`).then(response => {
          this.surveyBody = response.data.body
          if (this.current_vt.data_type_category) this.surveyResult.question1 = this.reversedDataTypeCategory[this.current_vt.data_type_category]
          if (this.current_vt.number_of_persons) this.surveyResult.question2 = this.reversedPersonNumber[this.current_vt.number_of_persons]
          $('#' + objectModalName.riskSurvey).modal('show')
        }).catch(error => this.$vToastify.error(String(error)))
      },
      updateSimpleRiskAnalysis(surveyResult) {
        if (this.current_vt.number_of_persons !== surveyResult.numberOfPersons || this.current_vt.data_type_category !== surveyResult.dataTypeCategory) {
          this.current_vt.number_of_persons = surveyResult.numberOfPersons
          this.current_vt.data_type_category = surveyResult.dataTypeCategory
          service.request({
            url: `todos/v1/patch_vt/${this.current_vt.id}/`,
            method: 'PUT',
            responseType: 'json',
            data: {
              id: this.current_vt.id,
              number_of_persons: surveyResult.numberOfPersons,
              data_type_category: surveyResult.dataTypeCategory,
              risk_level: surveyResult.riskAnalysis.risk_level
            }
          }).then((response) => {
            this.current_vt = response.data
            this.current_vt.risk_level = surveyResult.riskAnalysis.risk_level
            this.currentRiskAnalysis = surveyResult.riskAnalysis
            this.current_vt.risk_analysis = this.currentRiskAnalysis
            const vtID = this.vt_list.findIndex(item => item.id === this.current_vt.id)
            this.vt_list[vtID] = this.current_vt
            this.table.clear().rows.add(this.vt_list).draw(false)
            $('#' + objectModalName.riskSurvey).modal('hide')
          }).catch(function (err) {
            console.log(err)
          })
        }
      },
      addNewRiskAnalysis (e, mode, action) {
        let modal = $('.DTE')
        const id = e.currentTarget.ids()[0]
        const that = this
        if (modal.find('.DTE_Field_Name_risk_level').length > 0) {
          $(`<div class="row" style="padding-top: 10px; margin-top: 10px; border-top: 1px solid grey"><a class="editor-new-risk btn btn-outline-info" data-vt-id="${id}" href="#">Komplette Risikobewertung durchführen</a></div>
                <div class="row" style="padding-top: 10px; margin-top: 10px; border-top: 1px solid grey"><a class="editor-simple-risk btn btn-outline-secondary" data-vt-id="${id}" href="#">Einfache Risikobewertung durchführen</a></div>`).appendTo(modal.find('.DTE_Field_Name_risk_remarks').parent())
          $('.editor-new-risk').off('click').on('click', function(e) {
            e.preventDefault()
            const vtID = $(this).data('vt-id')
            that.editor.close()
            that.triggerCompleteRiskAnalysis(vtID)
          })
          $('.editor-simple-risk').off('click').on('click', function(e) {
            e.preventDefault()
            const vtID = $(this).data('vt-id')
            that.editor.close()
            that.triggerSimpleRiskAnalysis(vtID)
          })
          modal.find('.DTE_Field_Name_risk_level .DTE_Field_InputControl').children('div').css('display', 'flex')
        }
      },
      triggerCompleteRiskAnalysis(vtID) {
        const vt = this.vt_list.find(item => item.id === vtID)
        this.current_vt = vt
        this.currentRiskAnalysis = deepCopy(newRiskAnalysis)
        this.currentRiskAnalysis.vt = vtID
        this.currentRiskAnalysis.vt_detail = {id: vtID, name: vt.name, customer: vt.customer}
        this.current_vt.risk_analysis = this.currentRiskAnalysis
        $('#'+objectModalName.riskAnalysis).modal('show')
      },
      triggerSimpleRiskAnalysis(vtID) {
        const vt = this.vt_list.find(item => item.id === vtID)
        this.current_vt = vt
        this.currentRiskAnalysis = deepCopy(newRiskAnalysis)
        this.currentRiskAnalysis.vt = vtID
        this.currentRiskAnalysis.vt_detail = {id: vtID, name: vt.name, customer: vt.customer}
        this.current_vt.risk_analysis = this.currentRiskAnalysis
        this.openSimpleRiskSurvey()
      },
      updateTodo(todoObject) {
        const todoIndex = this.current_vt.tasks.findIndex(task => task.id === todoObject.id)
        if (todoIndex === -1) {
          this.current_vt.tasks.push(todoObject)
        } else {
          this.current_vt.tasks[todoIndex] = todoObject
        }
        const vtIndex = this.vt_list.findIndex(item => item.id === this.current_vt.id)
        this.vt_list[vtIndex] = this.current_vt
        this.table.clear().rows.add(this.vt_list).draw(false)
        $('#add_massnahme').modal('hide')
        this.$vToastify.success('Maßnahme ist erfolgreich gespeichert!')
      },
      getRiskMeta() {
        service.request({
          url: 'todos/v1/get_risk_meta/',
          method: 'GET',
          responseType: 'json'
        }).then((response)=>{
          this.bsiGroups = response.data.bsi_group
          this.dsgvoGroups = response.data.dsgvo_group
          this.verboseName = response.data.verbose_name
          this.helpText = response.data.help_text
        }).catch(function(err) {
          console.log(err)
        })
      },
      changeEditTodo(value) {
        this.editTodo = value
      },
      showVT(objectID) {
        this.current_vt = this.vt_list.filter(item => item.id == objectID)[0]
        $('#' + objectModalName.vt).modal('show')
      },
      setVT(vtObject) {
        updateDepartments(vtObject.departments, this.editor)
        updateDataTypes(vtObject.data_type, this.editor)
        updatePersonGroups(vtObject.affected_person, this.editor)
        const vtIndex = this.vt_list.findIndex(item => item.id === vtObject.id)
        if (vtIndex === -1) {
          this.vt_list = this.vt_list.map(item => {
            item.sequence = item.sequence + 1
            return item
          })
          this.vt_list.push(vtObject)
        }
        else {
          this.vt_list[vtIndex] = vtObject
        }
        this.table.clear().rows.add(this.vt_list).draw(false)
        this.$store.commit('SET_VTS', this.vt_list)
      },
      setSystem(systemObject) {
        this.current_system = systemObject
        updateSystems(systemObject, this.editor)
        updateDepartments([systemObject.department], this.editor)
      },
      setRiskAnalysis(riskAnalysis) {
        this.currentRiskAnalysis = riskAnalysis
        this.current_vt.risk_analysis = riskAnalysis
        this.current_vt.risk_level = riskAnalysis.risk_level
        const vtID = this.current_vt.id
        const vtIndex = this.vt_list.findIndex(item => item.id === vtID)
        this.vt_list[vtIndex] = this.current_vt
        this.table.clear().rows.add(this.vt_list).draw(false)
      },
      setSupplier(supplierObject) {
        this.current_supplier = supplierObject
        updateSuppliers(supplierObject, this.editor)
        updateDepartments([supplierObject.responsible_department], this.editor)
      },
      extraActions(data) {
        return `<a class="dropdown-item related-task" href="#" data-vt-id="${data.id}">Verbundene Maßnahme</a><a class="dropdown-item add-task" href="#" data-vt-id="${data.id}">Maßnahme erstellen</a>`
      },
      setSteps(steps) {
        this.currentTodo.steps = steps
      },
      setTable(table) {
        this.table = table
        this.highlightUnreleasedRows()
      },
      setEditor(editor) {
        this.editor = editor
        this.editor.field('departments').update(this.selectDepartmentOptions)
        this.editor.field('system').update(this.selectSystemOptions)
        this.editor.field('supplier').update(this.selectSupplierOptions)
        this.editor.field('affected_person').update(this.selectPersonGroupsOptions)
        this.editor.field('data_type').update(this.selectDataTypeOptions)
      },
      highlightUnreleasedRows() {
        const table = this.table || ($('#dkl-table').length && $.fn.dataTable.isDataTable('#dkl-table') ? $('#dkl-table').DataTable() : null)
        if (!table) return
        table.rows().every(function() {
          const data = this.data()
          const node = this.node()
          if (node) {
            if (data && !data.released) {
              $(node).addClass('vt-unreleased')
            } else {
              $(node).removeClass('vt-unreleased')
            }
          }
        })
      },
      drawCallbackFunctions() {
        const that = this
        this.highlightUnreleasedRows()
        $('.related-risk').off('click').on('click', function(e) {
          e.preventDefault();
          const vtID = $(this).data('vt-id')
          that.current_vt = that.vt_list.find(item => item.id === vtID)
          that.currentRiskAnalysis = that.current_vt.risk_analysis
          $('#'+objectModalName.riskAnalysis).modal('show');
        })
        $('.related-system').off('click').on('click', function(e) {
          e.preventDefault();
          let system_id = $(this).data('system-id')
          const vtID = $(e.target).data('vt-id')
          that.editSystem = false
          that.current_vt = that.vt_list.filter(item => item.id === vtID)[0]
          if (system_id != 'null' && system_id != null) {
            service.request({
              url: `todos/v1/get_system/${system_id}/`,
              method: 'GET',
              responseType: 'json'
            }).then((response)=>{
              that.current_system = response.data;
              $('#'+objectModalName.system).modal('show');
            }).catch(function(err) {
              console.log(err)
            })
          } else {
            that.current_system = deepCopy(that.new_system)
            $('#'+objectModalName.system).modal('show')
          }
          if (that.editor != null && that.editor.display()) {
            that.editor.display(false)
          }
        })
        $('.add-system').off('click').on('click', function(e) {
          e.preventDefault();
          that.current_system = deepCopy(newSystem)
          $('#related_system').modal('show');
        })
        $('.related-supplier').off('click').on('click', function(e) {
          e.preventDefault();
          let supplier_id = $(this).data('supplier-id')
          const vtID = $(e.target).data('vt-id')
          that.editSupplier = false
          that.current_vt = that.vt_list.filter(item => item.id === vtID)[0]
          if (supplier_id != 'null' && supplier_id != null) {
            service.request({
              url: `todos/v1/get_supplier/${supplier_id}/`,
              method: 'GET',
              responseType: 'json'
            }).then((response)=>{
              that.current_supplier = response.data;
              $('#'+objectModalName.supplier).modal('show');
            }).catch(function(err) {
              console.log(err)
            })
          } else {
            that.current_supplier = deepCopy(newSupplier)
            $('#'+objectModalName.supplier).modal('show')
          }
          if (that.editor != null && that.editor.display()) {
            that.editor.display(false)
          }
        })
        $('.add-supplier').off('click').on('click', function(e) {
          e.preventDefault();
          that.current_supplier = deepCopy(newSupplier)
          $('#'+objectModalName.supplier).modal('show');
        })
        $('.related-task').off('click').on('click', function(e) {
          e.preventDefault();
          let vt_id = $(e.target).data('vt-id');
          that.gotoTasks(vt_id)
        })
        $('.add-task').off('click').on('click', function(e) {
          e.preventDefault();
          const vtID = $(e.target).data('vt-id');
          that.addTodo(vtID)
        })
        $('.single-task').off('click').on('click', function(e) {
          e.preventDefault();
          const taskID = $(e.target).data('task-id');
          const vtID = $(e.target).data('vt-id');
          that.current_vt = that.vt_list.filter(vt => vt.id === vtID)[0]
          service.request({
            url: `todos/v1/get_task/${taskID}/`,
            method: 'GET',
            responseType: 'json'
          }).then((response)=>{
            that.currentTodo = response.data;
            that.editTodo = false;
            $('#add_massnahme').modal('show');
          })
        })
        $('.show-comments').off('click').on('click', (e) => {
          const spanItem = $(e.target).closest('span')
          const vtId = spanItem.data('vt-id')
          that.currentComments = that.vt_list.filter(item => item.id === vtId)[0].comments
          // const rect = e.target.getBoundingClientRect(); // get some poition, scale,... properties of the item
          const mousePos = {}
          mousePos.x = e.clientX; // get the mouse position relative to the element
          mousePos.y = e.clientY;
          $('#current-comments').css('left', mousePos.x + "px"); // set the modal position to the last stored position
          $('#current-comments').css('top', mousePos.y + "px");
          $('#current-comments').show()
        })
      },
      addTodo(vtID) {
        this.currentTodo = deepCopy(newTodo)
        this.editTodo = true
        this.currentTodo.object_id = vtID
        this.currentTodo.model = 'vt'
        this.current_vt = this.vt_list.filter(item => item.id === vtID)[0]
        $('#add_massnahme').modal('show');
      },
      openVTSelectModal() {
        $('#templateVT').val('').trigger('change')
        $('#copyVT').val('').trigger('change')
        $('#copy-vt').modal('toggle')
      },
      chooseVT (mode) {
        const that = this
        if (mode === 'new') {
          this.current_vt = deepCopy(newVT)
        } else {
          if (this.selectedVT.startsWith('vorlage')) {
            const vtID = this.selectedVT.split('-')[1]
            service.request({
              url: `todos/v1/vt_template/${vtID}/`,
              method: 'GET',
              responseType: 'json',
            }).then(response => {
              that.current_vt = response.data
              that.current_vt.id = null
              that.current_vt.customer = that.account.name
            })
          } else {
            this.current_vt = this.vt_list.filter(item => item.id === parseInt(this.selectedVT))[0]
            this.current_vt.id = null
          }
        }
        $('#copy-vt').modal('toggle')
        this.openNewTVModal()
        return true
      },
      // updateDepartments(departments) {
      //   const newDepartments = []
      //   departments.forEach(department => {
      //     if (!this.departments.some(item => item.text === department)) {
      //       newDepartments.push({
      //         id: department,
      //         text: department
      //       })
      //     }
      //   })
      //   if (newDepartments.length > 0) {
      //     this.setDepartments(this.departments.concat(newDepartments))
      //     if (this.editor != null) this.editor.field('departments').update(this.selectDepartmentOptions)
      //   }
      // },
      // updateSystems(system) {
      //   if (!this.systems.includes(system.name)) {
      //     this.setSystems(this.systems.concat([system.name]))
      //     if (this.editor != null) this.editor.field('system').update(this.selectSystemOptions)
      //   }
      // },
      async getTemplateVTHeaders() {
        await service.request({
          url: `todos/v1/vt_template_headers/`,
          method: 'GET',
          responseType: 'json'
        }).then(response => {
          $('#templateVT').select2({
            width: '100%',
            dropdownParent: $('#copy-vt'),
            allowClear: true,
            placeholder: "--------",
            data: response.data
          })
        })
      },
      toggle_column(event, column_index) {
        // Get the column API object
        let column = $('.datatable').DataTable().column(column_index);

        // Toggle the visibility
        column.visible(!column.visible());

        // adjust dropdown menu
        if (column.visible() && !$(event.target).hasClass('selected')) {
          $(event.target).addClass('selected')
        } else if (!column.visible() && $(event.target).hasClass('selected')) {
          $(event.target).removeClass('selected');
        }
      },
      close_help() {
        $('#modal-help').hide()
      },
      submitAnswer: function(survey_result) {
        let return_data = []
        let data = []
        let current_answer = {}
        let question_id = ''
        let question_answer = {}
        let active = true
        const that = this
        for (const [key, value] of Object.entries(survey_result.data)) {
          if (key.substring(key.length - 9) === '-Document' || key.substring(key.length - 8) === '-Comment') {
            question_id = key.substring(8, key.indexOf('-'))
            let current_element = return_data.find(function(element) {
              return element.question === question_id
            })
            if (key.substring(key.length - 9) === '-Document') {
              current_element.question_answer.document = { 'name': value.name, 'path': value.path, 'version': value.version }
            } else current_element.question_answer.comment = value
          } else {
            question_id = key.substring(8)
            question_answer = { 'answer': value, 'comment': '', 'document': {}}
            active = true
            current_answer = { 'question': question_id, 'question_answer': question_answer, 'active': active,
              'modified_by': that.$store.getters.id }
            return_data.push(current_answer)
          }
        }
        if (that.original_answers.length > 0) {
          return_data.forEach(function(item, index) {
            let original_answer = that.original_answers.find(element => {
              return String(element.question) === String(item.question)
            })
            if (original_answer !== undefined) {
              if (JSON.stringify(original_answer.question_answer) !== JSON.stringify(item.question_answer)) {
                data.push(item)
              }
            } else {
              data.push(item)
            }
          })
        }
        service.request({
          url: 'todos/v1/answers/',
          method: 'POST',
          data: { 'answers': data },
          contentType: 'application/json; charset=utf-8'
        }).then(function(response) {
          console.log('ready')
        }).catch(function(err) {
          console.log(err)
        })
      },
      async getQuestions() {
        service.request({
          url: `todos/v1/vt/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then((response) => {
          this.vt_list = response.data;
          this.$store.commit('SET_VTS', response.data)
          if (this.table) {
            this.table.clear().rows.add(this.vt_list).draw(false)
          }
          this.promiseFinished = true
        })
      },
      gotoTasks(vtID) {
        this.$router.push({name: 'massnahmenplan', params: {questionID: vtID, questionDescription: vtID.toString(), model: 'vt'}})
      },
      openNewTVModal() {
        this.current_vt.customer = this.account.name
        $('#' + objectModalName.vt).modal('show')
      },
    }
  }
</script>
<style scoped>
  /*.modal-backdrop.show:nth-of-type(even) {*/
    /*z-index: 1051 !important;*/
  /*}*/
  .dkl-title-h4 {
    background-color: #f3f1f1;
    align-items: center;
  }
  .strikethrough {
    text-decoration: line-through;
  }
  .dkl-bg-offen, .dkl-bg-prioa {
    color: #ff0000;
  }
  .dkl-bg-abgeschlossen, .dkl-bg-prioc {
    color: #009900;
  }
  .dkl-bg-priob {
    color: orange;
  }
  .dkl-span-new-line {
    display: block;
  }
  .btn-shown-hover {
    display: none;
    position: absolute;
    top: 40%;
  }

  .z-index-0 {
    z-index: 0!important;
  }

  .btn-shown-right {
    right: 20px;
  }

  .btn-shown-left {
    left: 20px;
    z-index: 2;
  }

  .table-responsive:hover .btn-shown-hover, .btn-shown-hover:hover {
    display: inline-block;
  }

  .select2-results__option[aria-selected=true] { display: none;}

  .info-popup {
    display: none;
    position: absolute;
    color: #333333;
    padding: 5px;
    border: solid 1px #ddd;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 10px;
    text-align: center;
    width: 10%;
  }

  ::v-deep #dkl-table tbody tr.vt-unreleased:not(.selected),
  ::v-deep #dkl-table tbody tr.vt-unreleased:not(.selected) > td,
  ::v-deep #dkl-table tbody tr.vt-unreleased:not(.selected) > th,
  ::v-deep #dkl-table tbody tr.vt-unreleased:not(.selected) > .dtfc-fixed-left {
    background-color: #ffebee !important;
  }

  ::v-deep #dkl-table tbody tr.vt-unreleased:not(.selected):hover,
  ::v-deep #dkl-table tbody tr.vt-unreleased:not(.selected):hover > td,
  ::v-deep #dkl-table tbody tr.vt-unreleased:not(.selected):hover > th,
  ::v-deep #dkl-table tbody tr.vt-unreleased:not(.selected):hover > .dtfc-fixed-left {
    background-color: #fee2e2 !important;
  }
</style>
<style>
  #dkl-table tbody tr.vt-unreleased:not(.selected),
  #dkl-table tbody tr.vt-unreleased:not(.selected) > td,
  #dkl-table tbody tr.vt-unreleased:not(.selected) > th,
  #dkl-table tbody tr.vt-unreleased:not(.selected) > .dtfc-fixed-left {
    background-color: #ffebee !important;
  }

  #dkl-table tbody tr.vt-unreleased:not(.selected):hover,
  #dkl-table tbody tr.vt-unreleased:not(.selected):hover > td,
  #dkl-table tbody tr.vt-unreleased:not(.selected):hover > th,
  #dkl-table tbody tr.vt-unreleased:not(.selected):hover > .dtfc-fixed-left {
    background-color: #fee2e2 !important;
  }
</style>
